<ul class="sub-menu">
  <li (click)="openTab('trailer')" [ngClass]="{ active: isTrailerOpen }">
    {{ 'semi_trailer' | translate }}
  </li>
  @if (isSet) {
    <li (click)="openTab('semitrailer')" [ngClass]="{ active: isSemitrailerOpen }">
      {{ 'trailer' | translate }}
    </li>
  }
</ul>
<div class="container">
  <form class="form" #f="ngForm" (keyup.enter)="onSubmit()" [formGroup]="form">
    @if (isTrailerOpen) {
      <div class="wheel-form-trailer">
        <div class="input-row">
          <div class="input-container">
            <label class="label">{{ 'floor_distance' | translate | unit: 'length':true }}</label>
            <gl-input-container [glPremium]="true" class="input" [isErrorVisible]="true">
              <input [numericType]="'float'" formControlName="floorHeight" normal-input type="text" />
            </gl-input-container>
          </div>
          <div class="input-container">
            <label class="label">{{ 'floor_thickness' | translate | unit: 'length':true }}</label>
            <gl-input-container [glPremium]="true" class="input" [isErrorVisible]="true">
              <input
                [numericType]="'float'"
                formControlName="floorThickness"
                normal-input
                type="text"
                />
            </gl-input-container>
          </div>
          <div class="input-container">
            <label class="label">{{
              'floor_maximum_capacity' | translate | unit: 'weight':true
            }}</label>
            <gl-input-container [glPremium]="true" class="input" [isErrorVisible]="true">
              <input
                [numericType]="'float'"
                formControlName="floorMaximumCapacity"
                normal-input
                type="text"
                />
            </gl-input-container>
          </div>
        </div>
      </div>
    }
    @if (isSemitrailerOpen) {
      <div class="wheel-form-semitrailer">
        <div class="input-row">
          <div class="input-container">
            <label class="label">{{ 'floor_distance' | translate | unit: 'length':true }}</label>
            <gl-input-container [glPremium]="true" class="input" [isErrorVisible]="true">
              <input
                [numericType]="'float'"
                formControlName="floorHeight2"
                normal-input
                type="text"
                />
            </gl-input-container>
          </div>
          <div class="input-container">
            <label class="label">{{ 'floor_thickness' | translate | unit: 'length':true }}</label>
            <gl-input-container [glPremium]="true" class="input" [isErrorVisible]="true">
              <input
                [numericType]="'float'"
                formControlName="floorThickness2"
                normal-input
                type="text"
                />
            </gl-input-container>
          </div>
          <div class="input-container">
            <label class="label">{{
              'floor_maximum_capacity' | translate | unit: 'weight':true
            }}</label>
            <gl-input-container [glPremium]="true" class="input" [isErrorVisible]="true">
              <input
                [numericType]="'float'"
                formControlName="floorMaximumCapacity2"
                normal-input
                type="text"
                />
            </gl-input-container>
          </div>
        </div>
      </div>
    }
    <div class="right-column">
      @if (isTrailerOpen) {
        <div class="visualisation-container">
          <gl-loading-space-preview
            [project]="project"
            [width]="370"
            [height]="220"
            view="left"
            [loadingSpaceType]="loadingSpaceMod"
            [isOrto]="true"
          ></gl-loading-space-preview>
        </div>
      }
      @if (isSemitrailerOpen) {
        <div class="visualisation-container">
          <gl-loading-space-preview
            [project]="project"
            [width]="370"
            [height]="220"
            view="setLeft"
            [loadingSpaceType]="loadingSpaceMod"
            [isOrto]="true"
          ></gl-loading-space-preview>
        </div>
      }
    </div>
  </form>
  <div class="buttonRow">
    <button (click)="formReset()" outline-icon-button>
      <gl-icon name="delete"></gl-icon>
    </button>
    <button (click)="reload()" outline-icon-button>
      <gl-icon name="startArrangement"></gl-icon>
    </button>
  </div>
</div>
